import React, { useState, useContext } from "react";
import * as ProductionOrderSapService from "../../../../services/ProductionOrderSapService"; // Está mal
import PaginateList from "../../../../components/utils/PaginateList";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./productionOrderSapList.styled";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { useDispatch } from "react-redux";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import {
  POSAP_STATUS,
  POSAP_STATUS_ERROR,
  POSAP_STATUS_PENDING,
  POSAP_STATUS_READY_TO_SEND,
} from "../../../../constants";
import { useProductionOrderSapExtraInfo } from "../hook/useProductionOrderSapExtraInfo";
import { Tooltip as ReactTooltip } from "react-tooltip";

const ProductionOrderSapListContainer = ({ filters }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);
  const refresh = () => {
    setForceRefresh(true);
  };
  const { addExtraInfo, notify } = useProductionOrderSapExtraInfo(refresh);

  const columns = [
    {
      header: t("forms.productionOrderSap.table.head.init"),
      accessorKey: "sapStartDate",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.productionOrderSap.table.head.created"),
      accessorKey: "createdAt",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.productionOrderSap.table.head.idOrderSap"),
      accessorKey: "idOrderSap",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.productionOrderSap.table.head.plant"),
      accessorKey: "sapPlant",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.productionOrderSap.table.head.product"),
      accessorKey: "sapProduct",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.productionOrderSap.table.head.quantity"),
      accessorKey: "sapQuantity",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.productionOrderSap.table.head.version"),
      accessorKey: "sapProductionVersion",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.productionOrderSap.table.head.type"),
      accessorKey: "type",
      cell: (info) => {
        let type = info.getValue();
        if (info.row?.original?.sapProductionVersion === "0004") {
          type = "REPROCESO PARTIDORA";
        }
        return type;
      },
    },
    {
      header: t("forms.productionOrderSap.table.head.status"),
      accessorKey: "status",
      cell: (info) => {
        const type = POSAP_STATUS.find((st) => st.code === info.getValue());
        // console.log(info.getValue());
        if (info.getValue() === POSAP_STATUS_ERROR.code) {
          const errorMsg = info.row?.original?.errorMessage
            ? info.row?.original?.errorMessage[0].Text
            : t(type.label);
          return (
            <>
              <span
                data-tooltip-id={info.row?.original?.uuid}
                data-tooltip-content={errorMsg}
                data-tooltip-delay-hide={1000}
                style={{ cursor: "pointer", color: "#dc3545" }}
              >
                {t(type.label)}{" "}
                <i className="fa-solid fa-circle-exclamation"></i>
              </span>
              <ReactTooltip
                events={["click"]}
                effect="solid"
                id={info.row?.original?.uuid}
                style={{ maxWidth: "400px" }}
              />
            </>
          );
        }
        return type ? t(type.label) : info.getValue();
      },
    },
    {
      header: t("forms.order.table.head.actions"),
      accessorKey: "uuid",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const goToDetail = (uuid) => {
    navigate(`/factory/productionOrderSap/detail/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <>
        <div className="dropdown text-center">
          <button
            type="button"
            className="btn btn-secondary dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {t("forms.order.table.head.actions")}
          </button>
          <ListOptions className="dropdown-menu dropdown-menu-lg-end">
            <Option>
              <ButtonAction
                type="button"
                title={t("forms.productionOrderSap.labels.detail")}
                onClick={() => {
                  goToDetail(data.uuid);
                }}
              >
                <Icon className="fa-solid fa-circle-info"></Icon>
                {t("forms.productionOrderSap.labels.detail")}
              </ButtonAction>
            </Option>
            {data.status === POSAP_STATUS_PENDING.code && (
              <Option>
                <ButtonAction
                  title={t("forms.productionOrderSap.labels.extraInfo")}
                  type="button"
                  onClick={() => addExtraInfo(data.uuid)}
                >
                  <Icon className="fa-solid fa-file-pen"></Icon>
                  {t("forms.productionOrderSap.labels.extraInfo")}
                </ButtonAction>
              </Option>
            )}
            {(data.status === POSAP_STATUS_READY_TO_SEND.code ||
              data.status === POSAP_STATUS_ERROR.code) && (
              <Option>
                <ButtonAction
                  title={t("forms.productionOrderSap.labels.notify")}
                  type="button"
                  onClick={() => {
                    notify(data.uuid);
                  }}
                >
                  <Icon className="fa-solid fa-bell"></Icon>
                  {t("forms.productionOrderSap.labels.notify")}
                </ButtonAction>
              </Option>
            )}
          </ListOptions>
        </div>
      </>
    );
  };

  const listData = async (filter) => {
    if (!filter) {
      filter = {};
    }
    const result = await ProductionOrderSapService.listFilterProductionOrderSap(
      filter
    );

    return result;
  };

  const hiden = {};
  let resize = null;

  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={columns}
        toList={listData}
        hideColum={hiden}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
    </>
  );
};

ProductionOrderSapListContainer.propTypes = {};

export default ProductionOrderSapListContainer;
